import StaticSelector from "components/Atoms/StaticSelector"
import DynamicSelector from "components/Molecules/DynamicSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import { GROUPS } from "graphql/selector.queries.gql"
import useAuth from "hooks/useAuth"
import React from "react"
import { useFilter } from "store/search-filter/search-filter.reducer"
import { DAY_INTERVALS, USER_STATUSES } from "data/static.items"

const VendorFilter = () => {
  const [filter, setFilter] = useFilter("vendors")

  const { distributionCentres } = useAuth()
  return (
    <SearchFilter
      className="ml-3"
      value={filter}
      getValues={setFilter}
      onClear={() => setFilter({})}
    >
      <SearchFilterCallout title="Customer Type">
        <DynamicSelector
          inline
          label="Type"
          className="mb-0 mt-3"
          query={GROUPS}
          path="group"
          variables={{ category: "RTL" }}
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Order Frequency">
        <StaticSelector
          className="mt-3"
          inline
          label="Active Since"
          path="active"
          items={DAY_INTERVALS}
        />
        <StaticSelector
          inline
          label="Inactive Since"
          path="inactive"
          items={DAY_INTERVALS}
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Status">
        <StaticSelector
          inline
          className="mt-3"
          label="User"
          path="status"
          items={USER_STATUSES}
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Distribution Center">
        <StaticSelector
          items={distributionCentres}
          path="distributionCenterId"
        />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default VendorFilter
